module.exports = __webpack_public_path__ + "static/media/upload.b5603041.svg";